export default {
  "01": "1546731510009172042", // 发布会直播
  "02": "1547516105860329548", // HYDEOUT 电音节
};
